import { render, staticRenderFns } from "./Kink.vue?vue&type=template&id=0831cc62&scoped=true&"
import script from "./Kink.vue?vue&type=script&lang=ts&"
export * from "./Kink.vue?vue&type=script&lang=ts&"
import style0 from "./Kink.vue?vue&type=style&index=0&id=0831cc62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831cc62",
  null
  
)

export default component.exports